import React, { useState, useEffect } from "react";
import { Navigate } from "react-router-dom";
import { Column, TotalItem, Summary, GroupItem, SortByGroupSummaryInfo } from "devextreme-react/data-grid";
import DateBox from 'devextreme-react/date-box';
import { PaginaCreacionLibre } from "../../../Componentes/Compuestos/Paginas/PaginaCreacionLibre";
import { LVGridCabeceraReporte } from "../../../Componentes/Basicos/LVGridCabeceraReporte";
import { CheckBox } from "devextreme-react";

export const VEN_Reporte_DocsVenta_AgrupadoPorVendedorZona = () => {
  const [loading, setLoading] = useState(true)
  const [data, setData] = useState([])
  const [umBasica, setUMBasica] = useState([])
  const [globalUsaArticulosConPresentacion, setGlobalUsaArticulosConPresentacion] = useState([])
  const [globalUsaArticulosConTamano, setGlobalUsaArticulosConTamano] = useState([])
  const [globalUsaArticulosConUnidadDeMedida, setGlobalUsaArticulosConUnidadDeMedida] = useState([])
  const { VariablesGenerales: { DiasParaDesdeListados, DiasParaHastaListados } } = require('neftis7_apicaller');
  const [FechaDesde, setFechaDesde] = useState(new Date(DiasParaDesdeListados !== 0 ? new Date().setDate(new Date().getDate() + DiasParaDesdeListados) : Date.now()));
  const [FechaHasta, setFechaHasta] = useState(new Date(DiasParaHastaListados !== 0 ? new Date().setDate(new Date().getDate() + DiasParaHastaListados) : Date.now()));
  const { Varios: { FormateoFechaPara_yyyyMMdd,
    ObtieneParametros,
    TratamientoDeVariableBoolean } } = require('neftis7_apicaller');
  const { VEN_DocsVenta_Cabecera: { function_VEN_DocsVenta_Cabecera_ListarAgrupadoPorArticuloVZ,
    function_VEN_DocsVenta_Cabecera_ListarAgrupadoPorArticuloVZUMBasica } } = require('neftis7_apicaller');

  const onValueChangedFechaDesde = (nuevaFecha) => {
    setFechaDesde(nuevaFecha.value);
  };

  const onValueChangedFechaHasta = (nuevaFecha) => {
    setFechaHasta(nuevaFecha.value);
  };

  const onValueChangedUMBasica = (checked) => {
    setUMBasica(checked.value);
  };

  const getData = async () => {
    // Llama a función asíncrona y maneja los datos
    try {
      let resultData;

      if (umBasica) {
        resultData = await function_VEN_DocsVenta_Cabecera_ListarAgrupadoPorArticuloVZUMBasica(await FormateoFechaPara_yyyyMMdd(FechaDesde), await FormateoFechaPara_yyyyMMdd(FechaHasta), "NA*DA", "NA*DA", "NA*DA", "NA*DA");
      }
      else {
        resultData = await function_VEN_DocsVenta_Cabecera_ListarAgrupadoPorArticuloVZ(await FormateoFechaPara_yyyyMMdd(FechaDesde), await FormateoFechaPara_yyyyMMdd(FechaHasta), "NA*DA", "NA*DA", "NA*DA", "NA*DA");
      }

      setData(resultData.data)

    } catch (error) {
      alert("Error al obtener los datos: " + error);
    }
    setLoading(false)
  };

  const getDataParametros = async () => {
    // Llama a función asíncrona y maneja los datos
    try {
      const datosModificadores = await ObtieneParametros();
      const globalUsaArticulosConPresentacionLocal = await TratamientoDeVariableBoolean(datosModificadores.GlobalUsaArticulosConPresentacion)
      const globalUsaArticulosConTamanoLocal = await TratamientoDeVariableBoolean(datosModificadores.GlobalUsaArticulosConTamano)
      const globalUsaArticulosConUnidadDeMedidaLocal = await TratamientoDeVariableBoolean(datosModificadores.GlobalUsaArticulosConUnidadDeMedida)

      setGlobalUsaArticulosConPresentacion(globalUsaArticulosConPresentacionLocal)
      setGlobalUsaArticulosConTamano(globalUsaArticulosConTamanoLocal)
      setGlobalUsaArticulosConUnidadDeMedida(globalUsaArticulosConUnidadDeMedidaLocal)

    } catch (error) {
      alert("Error al obtener los datos: " + error);
    }
  };

  useEffect(() => {
    getData();
  }, [FechaDesde, FechaHasta, umBasica]); // Llamar a getData cuando FechaDesde o FechaHasta cambien

  useEffect(() => {
    const user = localStorage.getItem("user");
    const codigoCompania = localStorage.getItem("CodigoCompania");
    const codigoEmpresa = localStorage.getItem("CodigoEmpresa");
    const codigoPlanta = localStorage.getItem("CodigoPlanta");
    const idPersona = localStorage.getItem("IdPersona");

    // Verificar valores en localStorage
    if (!user || !codigoCompania || !codigoEmpresa || !codigoPlanta || Number(idPersona) < 1) {
      if (Number(idPersona) === -1 || Number(idPersona) === -2 || Number(idPersona) === -3) {
      } else {
        return <Navigate to={"/Login"} />;
      }
    }

    getDataParametros();
  }, []);

  return (
    <PaginaCreacionLibre
      Titulo="VENTAS - AGRUPADO POR VENDEDOR/ZONA"
    >
      {loading ? (
        <div className="card-body text-center">
          <div className="spinner-border" role="status">
            <span className="sr-only">Cargando...</span>
          </div>
        </div>
      ) : (
        <div className="card-body">

          <table >
            <tbody>
              <tr>
                <td width={120}>
                  <label>Rango de Datos</label>
                </td>
                <td width={160}>
                  <DateBox width={160} displayFormat="dd/MM/yyyy" value={FechaDesde} onValueChanged={onValueChangedFechaDesde} />
                </td>
                <td width={160}>
                  <DateBox width={160} displayFormat="dd/MM/yyyy" value={FechaHasta} onValueChanged={onValueChangedFechaHasta} />
                </td>
                <td width={50}>

                </td>
                <td >
                  <CheckBox onValueChanged={onValueChangedUMBasica} value={true} text="Unidad de Medida Básica" />
                </td>
              </tr>
            </tbody>
          </table>
          <div className="table-responsive">
            {data.length > 0 ? (
              <LVGridCabeceraReporte
                dataSource={data}
                id="gridContainer"
                keyExpr="CodigoArticulo"
              >
                <Summary>
                  <TotalItem
                    column="CodigoArticulo"
                    summaryType="count"
                    customizeText={summaryItem => `Registros: ${summaryItem.value}`} />
                  <TotalItem
                    column="Cantidad"
                    summaryType="sum"
                    customizeText={summaryItem => `${summaryItem.value.toFixed(1).replace(/\B(?=(\d{3})+(?!\d))/g, ',')}`}
                    valueFormat="number" />
                  <TotalItem
                    column="ImporteNeto"
                    summaryType="sum"
                    customizeText={summaryItem => `$ ${summaryItem.value.toFixed(1).replace(/\B(?=(\d{3})+(?!\d))/g, ',')}`}
                    valueFormat="currency" />
                  <TotalItem
                    column="ImporteIVA"
                    summaryType="sum"
                    customizeText={summaryItem => `$ ${summaryItem.value.toFixed(1).replace(/\B(?=(\d{3})+(?!\d))/g, ',')}`}
                    valueFormat="currency" />
                  <TotalItem
                    column="ImporteDescuentos"
                    summaryType="sum"
                    customizeText={summaryItem => `$ ${summaryItem.value.toFixed(1).replace(/\B(?=(\d{3})+(?!\d))/g, ',')}`}
                    valueFormat="currency" />
                  <TotalItem
                    column="ImporteRecargos"
                    summaryType="sum"
                    customizeText={summaryItem => `$ ${summaryItem.value.toFixed(1).replace(/\B(?=(\d{3})+(?!\d))/g, ',')}`}
                    valueFormat="currency" />
                  <TotalItem
                    column="ImporteTotal"
                    summaryType="sum"
                    customizeText={summaryItem => `$ ${summaryItem.value.toFixed(1).replace(/\B(?=(\d{3})+(?!\d))/g, ',')}`}
                    valueFormat="currency"
                    displayFormat="currency" />
                  <TotalItem
                    column="Peso"
                    summaryType="sum"
                    customizeText={summaryItem => `${summaryItem.value.toFixed(0).replace(/\B(?=(\d{3})+(?!\d))/g, ',')}`}
                    valueFormat="number" />

                  <GroupItem
                    column="CodigoArticulo"
                    summaryType="count"

                    displayFormat="Registros: {0} "
                    showInGroupFooter={true} />
                  <GroupItem
                    column="Cantidad"
                    summaryType="sum"
                    customizeText={summaryItem => `${summaryItem.value.toFixed(1).replace(/\B(?=(\d{3})+(?!\d))/g, ',')}`}
                    valueFormat="number"
                    showInGroupFooter={true} />
                  <GroupItem
                    column="ImporteNeto"
                    summaryType="sum"
                    customizeText={summaryItem => `$ ${summaryItem.value.toFixed(1).replace(/\B(?=(\d{3})+(?!\d))/g, ',')}`}
                    valueFormat="currency"
                    showInGroupFooter={true} />
                  <GroupItem
                    column="ImporteIVA"
                    summaryType="sum"
                    customizeText={summaryItem => `$ ${summaryItem.value.toFixed(1).replace(/\B(?=(\d{3})+(?!\d))/g, ',')}`}
                    valueFormat="currency"
                    showInGroupFooter={true} />
                  <GroupItem
                    column="ImporteDescuentos"
                    summaryType="sum"
                    customizeText={summaryItem => `$ ${summaryItem.value.toFixed(1).replace(/\B(?=(\d{3})+(?!\d))/g, ',')}`}
                    valueFormat="currency"
                    showInGroupFooter={true} />
                  <GroupItem
                    column="ImporteRecargos"
                    summaryType="sum"
                    customizeText={summaryItem => `$ ${summaryItem.value.toFixed(1).replace(/\B(?=(\d{3})+(?!\d))/g, ',')}`}
                    valueFormat="currency"
                    showInGroupFooter={true} />
                  <GroupItem
                    column="ImporteTotal"
                    summaryType="sum"
                    customizeText={summaryItem => `$ ${summaryItem.value.toFixed(1).replace(/\B(?=(\d{3})+(?!\d))/g, ',')}`}
                    valueFormat="currency"
                    displayFormat="currency"
                    showInGroupFooter={true} />
                  <GroupItem
                    column="ImporteTotal"
                    summaryType="sum"
                    customizeText={summaryItem => `IMPORTE TOTAL $ ${summaryItem.value.toFixed(1).replace(/\B(?=(\d{3})+(?!\d))/g, ',')}`}
                    valueFormat="currency"
                    displayFormat="currency"
                    showInGroupFooter={false} />
                  <GroupItem
                    column="Peso"
                    summaryType="sum"
                    customizeText={summaryItem => `${summaryItem.value.toFixed(0).replace(/\B(?=(\d{3})+(?!\d))/g, ',')}`}
                    valueFormat="number"
                    showInGroupFooter={true} />
                </Summary>

                <SortByGroupSummaryInfo
                  summaryItem="ImporteTotal"
                  sortOrder="desc" />

                <Column caption="Zona" alignment="Center" >
                  <Column caption="Código" dataField="CodigoZona" width="70" alignment="Left" dataType="string" visible={false} />
                  <Column caption="Descripción" dataField="Zona" width="200" alignment="Left" dataType="string" groupIndex={0} />
                </Column>
                <Column caption="Vendedor" alignment="Center" >
                  <Column caption="Código" dataField="IdProfesionalVendedorAsignado" width="70" alignment="Left" dataType="string" visible={false} />
                  <Column caption="Descripción" dataField="Vendedor" width="200" alignment="Left" dataType="string" groupIndex={1} />
                </Column>

                <Column caption="Artículo" alignment="Center">
                  <Column caption="Tipo" dataField="TipoVentas" width="100" alignment="Left" dataType="string" groupIndex={2} />
                  <Column caption="SubTipo" dataField="SubTipoVentas" width="100" alignment="Left" dataType="string" groupIndex={3} />
                  <Column caption="Código" dataField="CodigoArticulo" width="120" alignment="Left" dataType="string" />
                  <Column caption="Descripción" dataField="Descripcion" width="200" alignment="Left" dataType="string" />
                </Column>
                <Column caption="Presentación" alignment="Center" visible={globalUsaArticulosConPresentacion}>
                  <Column caption="Código" dataField="CodigoPresentacion" width="70" alignment="Left" dataType="string" visible={globalUsaArticulosConPresentacion} />
                  <Column caption="Descripción" dataField="Presentacion" width="200" alignment="Left" dataType="string" visible={globalUsaArticulosConPresentacion} />
                </Column>
                <Column caption="Tamaño" alignment="Center" visible={globalUsaArticulosConTamano} >
                  <Column caption="Código" dataField="CodigoTamano" width="70" alignment="Left" dataType="string" visible={globalUsaArticulosConTamano} />
                  <Column caption="Descripción" dataField="Tamano" width="150" alignment="Left" dataType="string" visible={globalUsaArticulosConTamano} />
                </Column>

                <Column caption="Unidad de Medida" alignment="Center" visible={globalUsaArticulosConUnidadDeMedida} >
                  <Column caption="Código" dataField="CodigoUnidadMedida" width="70" alignment="Left" dataType="string" visible={globalUsaArticulosConUnidadDeMedida} />
                  <Column caption="Descripción" dataField="UnidadMedida" width="150" alignment="Left" dataType="string" visible={globalUsaArticulosConUnidadDeMedida} />
                </Column>

                <Column caption="Cliente" alignment="Center" >
                  <Column caption="Código" dataField="IdCliente" width="70" alignment="Right" dataType="number" />
                  <Column caption="Descripción" dataField="Cliente" width="200" alignment="Left" dataType="string" />
                </Column>

                <Column caption="Cantidad" dataField="Cantidad" width="100" alignment="Right" dataType="number" />

                <Column caption="Unidad de Medida Venta" alignment="Center" visible={!umBasica}>
                  <Column caption="Código" dataField="CodigoUnidadMedidaVenta" width="70" alignment="Left" dataType="string" visible={!umBasica} />
                  <Column caption="Descripción" dataField="UnidadMedidaVenta" width="150" alignment="Left" dataType="string" visible={!umBasica} />
                </Column>
                <Column caption="Cantidad" dataField="CantidadVenta" width="100" alignment="Right" dataType="number" visible={!umBasica} />

                <Column caption="Importes" alignment="Center">
                  <Column caption="Neto" dataField="ImporteNeto" width="150" alignment="Right" dataType="number" format="currency" />
                  <Column caption="I.V.A." dataField="ImporteIVA" width="150" alignment="Right" dataType="number" format="currency" />
                  <Column caption="Descuentos" dataField="ImporteDescuentos" width="150" alignment="Right" dataType="number" format="currency" />
                  <Column caption="Recargos" dataField="ImporteRecargos" width="150" alignment="Right" dataType="number" format="currency" />
                  <Column caption="Total" dataField="ImporteTotal" width="150" alignment="Right" dataType="number" format="currency" />
                </Column>

                <Column caption="Peso" dataField="Peso" width="120" alignment="Right" dataType="number" />

              </LVGridCabeceraReporte>
            ) : (
              <div className="card-body text-center">
                <h5 className="card-title">No hay datos</h5>
              </div>
            )}
          </div>
        </div>
      )}
    </PaginaCreacionLibre>
  );
};
